import React, { useEffect, useRef, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, TaskListingColumns, TaskListingSellerColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { getAllTaskListing, getAllPackageTasks, getAllProductTasks } from '../../store/actions/picker.action';
import LoaderSpinner from '../common/Loader';
import ProductListingFilter from '../Inventory/Product/ProductListingFilter';
import _ from 'lodash';
import SearchCarrierConnect from '../CarrierConnect/SearchCarrierConnect';
import { taskBackDetails } from '../../store/actions/employee';

/*istanbul ignore next */
const TasksListing = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [dateRange, setDateRange] = useState([null, null]);
    const { taskPrevState } = useSelector((state) => state.employee);
    const [startDate, endDate] = dateRange;
    let dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.user);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const TASK_TABS = [
        { key: 'General', label: 'General Tasks' },
        { key: 'ReturnPackage', label: 'Return Package Tasks' },
        { key: 'ReturnProduct', label: 'Return Product Tasks' },
    ];
    const [activeTab, setActiveTab] = useState(taskPrevState?.taskCategory || 'General');
    const [showFilter, setShowFilter] = useState(false);
    // When the user clicks a tab manually, suppress the auto-tab-switch for the
    // next listing response so we don't override their explicit choice.
    const suppressAutoSwitchRef = useRef(false);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchKeyword: '',
        sellerIdList: [],
        companyIdList: [],
        taskTypeIdList: [],
        taskStatusIdList: [],
        taskPriorityIdList: [],
        taskStatusList: [],
        showSearch: false,
        startDate: null,
        endDate: null,
        searchText: '',
        taskCategory: 'General',
        // New filter fields (UI shell — payload wiring pending backend support)
        trackingNumber: '',
        productSku: '',
        packageTypeIdList: [],
        sourceIdList: [],
        carrierIdList: [],
        rmaCode: '',
        sellerProductId: '',
        returnProductTypeIdList: [],
        warehouseIdList: [],
    }

    const [filterData, setfilterData] = useState({});
    const { allTaskList, allTaskListStatus } = useSelector((state) => state.pickerReducer);
    const [allTasksList, setAllTasksList] = React.useState([]);
    // When the General (cross-search) API returns rows of mixed categories,
    // cache the enriched list so user tab clicks can be served from memory
    // without re-hitting the per-tab APIs (which may not support the same
    // search and would return empty / different rows).
    const [crossSearchData, setCrossSearchData] = useState(null);

    useEffect(() => {
        if (!_.isEmpty(taskPrevState)) {
            setfilterData({ ...filterData, ...taskPrevState });
        } else {
            setfilterData({ ...dataLoad });
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(filterData)) {
            getAllTasksList();
        }
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder, endDate, filterData.taskCategory]);

    const handleTabChange = (tabKey) => {
        if (tabKey === activeTab) return;
        suppressAutoSwitchRef.current = true;
        // When a cross-search cache is available, switch tabs purely in-memory
        // — no refetch, just re-filter the cached enriched list by the new tab.
        if (crossSearchData) {
            setActiveTab(tabKey);
            const filtered = crossSearchData.filter((i) => i.taskCategory === tabKey);
            setAllTasksList(filtered);
            setfilterData((prev) => ({
                ...prev,
                pageIndex: 1,
                totalPages: Math.ceil((filtered.length || 1) / (prev.pageSize || 30)),
            }));
            return;
        }
        setActiveTab(tabKey);
        setfilterData({
            ...filterData,
            taskCategory: tabKey,
            pageIndex: 1,
            // Reset tab-specific filter fields so they don't bleed across tabs
            trackingNumber: '',
            productSku: '',
            packageTypeIdList: [],
            sourceIdList: [],
            carrierIdList: [],
            rmaCode: '',
            sellerProductId: '',
            returnProductTypeIdList: [],
            warehouseIdList: [],
        });
    };

    const handleFilterApply = () => {
        // Any explicit filter / search submit invalidates the cross-search cache
        // and allows the next response to auto-route to the owning tab.
        setCrossSearchData(null);
        suppressAutoSwitchRef.current = false;
        setfilterData({ ...filterData, pageIndex: 1 });
        if (filterData.pageIndex === 1) {
            getAllTasksList();
        };
    }

    const dispatchTaskListing = (data) => {
        const tab = data.taskCategory || activeTab;
        // When a search keyword is active, always use the General (cross-search)
        // API so a single query can return rows of any task category. The
        // enrichment effect then routes each row to its owning tab and caches
        // the mixed list so tab clicks are served in-memory.
        const hasSearch = !!(data.searchText && String(data.searchText).trim());
        if (hasSearch) {
            dispatch(getAllTaskListing(data));
            return;
        }
        if (tab === 'ReturnPackage') {
            dispatch(getAllPackageTasks(data));
        } else if (tab === 'ReturnProduct') {
            dispatch(getAllProductTasks(data));
        } else {
            dispatch(getAllTaskListing(data));
        }
    };

    const getAllTasksList = () => {
        let data = {
            ...filterData,
            taskCategory: filterData.taskCategory || activeTab,
            searchText: filterData?.searchText?.trim(),
            startDate: startDate ? moment(startDate).format('YYYY-MM-DDT00:00:00') : null,
            endDate: endDate ? moment(endDate).format('YYYY-MM-DDT00:00:00') : null,
            taskTypeIdList: _.map(filterData.taskTypeIdList, "id"),
            taskStatusIdList: _.map(filterData.taskStatusList, "id"),
            taskPriorityIdList: _.map(filterData.taskPriorityIdList, "id"),
            companyIdList: _.map(filterData.companyIdList, "Id"),
            sellerIdList: _.map(filterData.sellerIdList, "id"),
        };
        dispatchTaskListing(data);
    }

    const getStatusClass = (status) => {
        switch (status) {
            case 'Hold':
                return 'activeStatus activeStatusRefunded';
            case 'In-Progress':
                return 'activeStatus taskInprogress';
            case 'Pending':
                return 'activeStatus activeStatusInprogress';
            case 'Completed':
                return 'activeStatus';
            case 'Canceled':
                return 'activeStatus activeStatusCanceled';
            case 'Closed':
                return 'activeStatus activeStatusClosed';
            default:
                return 'activeStatus uploads';
        }
    };

    // Map server taskReferenceType -> UI tab key so each row knows its
    // owning tab (used for per-row detail navigation).
    const mapRefTypeToCategory = (refType) => {
        if (refType === 'Package') return 'ReturnPackage';
        if (refType === 'Product') return 'ReturnProduct';
        return 'General';
    };

    // Pick the tab to focus after a cross-search response: prefer General
    // when it has rows; otherwise the first non-empty tab — but only if the
    // user's current tab has no matches (don't override an explicit choice).
    const pickAutoSwitchTarget = (enrichedList) => {
        if (enrichedList.some((i) => i.taskCategory === 'General')) {
            return 'General';
        }
        const tabOrder = ['ReturnPackage', 'ReturnProduct'];
        const firstTabWithRows = tabOrder.find((t) =>
            enrichedList.some((i) => i.taskCategory === t)
        );
        const activeHasRows = enrichedList.some((i) => i.taskCategory === activeTab);
        return !activeHasRows && firstTabWithRows ? firstTabWithRows : null;
    };

    const enrichTaskItem = (item) => {
        const derivedCategory = mapRefTypeToCategory(item?.taskReferenceType) || item?.taskCategory || activeTab;
        const packageTrackingNumber =
            item?.packageTrackingNumber ||
            (item?.taskReferenceType === 'Package' ? item?.taskReferenceDetails : '') ||
            '';
        const sku =
            item?.sku ||
            (item?.taskReferenceType === 'Product' ? item?.taskReferenceDetails : '') ||
            '';
        return {
            ...item,
            listIndex: item.id,
            taskCategory: derivedCategory,
            packageTrackingNumber,
            sku,
            taskStatusName: `<span class="${getStatusClass(item.taskStatusName)}">${item.taskStatusName}</span>`,
        };
    };

    useEffect(() => {
        if (allTaskListStatus === 'PENDING') {
            setLoader(true);
            return;
        }
        if (allTaskListStatus !== 'SUCCESS' || _.isEmpty(filterData)) return;

        const enrichedList = (allTaskList?.listTasks || []).map(enrichTaskItem);

        // Treat any response that came from a search query as a unified
        // cross-search result: cache the enriched list, auto-route the
        // active tab, and serve subsequent tab clicks from this cache
        // (see handleTabChange) without re-hitting any per-tab API.
        const hasSearchKeyword = !!(filterData?.searchText && String(filterData.searchText).trim());
        let nextActiveTab = activeTab;
        let cacheToStore = null;

        if (hasSearchKeyword && enrichedList.length > 0) {
            cacheToStore = enrichedList;
            if (!suppressAutoSwitchRef.current) {
                const targetCategory = pickAutoSwitchTarget(enrichedList);
                if (targetCategory && targetCategory !== activeTab) {
                    nextActiveTab = targetCategory;
                    setActiveTab(targetCategory);
                }
            }
        }
        setCrossSearchData(cacheToStore);
        suppressAutoSwitchRef.current = false;

        const displayList = cacheToStore
            ? cacheToStore.filter((i) => i.taskCategory === nextActiveTab)
            : enrichedList;

        const totalForPaging = cacheToStore
            ? (displayList.length || 1)
            : (allTaskList?.TotalRecords || 1);
        setfilterData({
            ...filterData,
            totalPages: Math.ceil(totalForPaging / filterData.pageSize),
        });
        setAllTasksList(displayList);
        setLoader(false);
    }, [allTaskListStatus]);

    const handleAction = (item, type) => {
        dispatch(taskBackDetails(filterData));
        navigate(`/tasks/${item.id}`, {
            state: {
                data: { ...item, taskCategory: item.taskCategory || activeTab },
                editable: type === 'view' ? false : true,
            },
        });
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
            pageIndex: 1
        });
    };

    const handleNavigate = () => {
        navigate(`/tasks/0`, {
            state: {
                data: {},
                editable: true,
            },
        });
    }

    const handleDateChange = (date) => {
        setDateRange(date);
    };

    const handleSearchText = (value) => {
        setfilterData({ ...filterData, searchText: value });
    };

    const handleReset = () => {
        setCrossSearchData(null);
        suppressAutoSwitchRef.current = false;
        const updatedFilterData = { ...filterData, searchText: '', pageIndex: 1 };
        setfilterData(updatedFilterData);

        // Call getAllTasksList with the updated data directly
        let data = {
            ...updatedFilterData,
            taskCategory: updatedFilterData.taskCategory || activeTab,
            searchText: '', // Explicitly set to empty string
            startDate: startDate ? moment(startDate).format('YYYY-MM-DDT00:00:00') : null,
            endDate: endDate ? moment(endDate).format('YYYY-MM-DDT00:00:00') : null,
            taskTypeIdList: _.map(updatedFilterData.taskTypeIdList, "id"),
            taskStatusIdList: _.map(updatedFilterData.taskStatusList, "id"),
            taskPriorityIdList: _.map(updatedFilterData.taskPriorityIdList, "id"),
            companyIdList: _.map(updatedFilterData.companyIdList, "Id"),
            sellerIdList: _.map(updatedFilterData.sellerIdList, "id"),
        };
        dispatchTaskListing(data);
    };

    const handleFilterReset = () => {
        setCrossSearchData(null);
        suppressAutoSwitchRef.current = false;
        setDateRange([null, null]);
        setfilterData((prevState) => ({
            ...prevState,
            pageIndex: 1,
            sellerIdList: [],
            companyIdList: [],
            taskTypeIdList: [],
            taskStatusIdList: [],
            taskStatusList: [],
            taskPriorityIdList: [],
            // Clear new filter fields too
            trackingNumber: '',
            productSku: '',
            packageTypeIdList: [],
            sourceIdList: [],
            carrierIdList: [],
            rmaCode: '',
            sellerProductId: '',
            returnProductTypeIdList: [],
            warehouseIdList: [],
        }));
        dispatchTaskListing({ ...dataLoad, taskCategory: activeTab });
        dispatch(taskBackDetails({}));
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec zIndex3">
                    <span>Tasks</span>
                </div>
                <div className='zIndex1'>
                    <SearchCarrierConnect
                        searchKeyword={filterData.searchText}
                        handleSearchText={handleSearchText}
                        handleSearchFilter={handleFilterApply}
                        handleReset={handleReset}
                        userDetails={userDetails}
                        placeholderText="Search by Company, Seller, Seller Code, STE Code, Title, Task Id, Comments, SKU, Tracking Number, Package Type, Source, Carrier, RMA Code, Seller Product Id, Return Product Type or Warehouse"
                    />
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap mt-2 px-3 taskListingToolbar">
                    <ul className="nav nav-tabs taskListingTabs mb-0">
                        {TASK_TABS.map((tab) => (
                            <li key={tab.key} className="nav-item">
                                <button
                                    type="button"
                                    className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                                    onClick={() => handleTabChange(tab.key)}
                                    disabled={loader}
                                >
                                    {tab.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="d-flex align-items-center top_right_button_container" style={{ gap: 8 }}>
                        <div className="taskDateRange" style={{ minWidth: 220 }}>
                            <DatePicker
                                className="date-picker form-control"
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => handleDateChange(update)}
                                dateFormat="MM-dd-yyyy"
                                isClearable={true}
                                placeholderText="Select Date Range"
                                showIcon
                                maxDate={new Date()}
                                popperClassName="taskDateRangePopper"
                                popperPlacement="bottom-end"
                            />
                        </div>
                        <button
                            type="button"
                            className="btn cus-seconday-bg-btn top-btn"
                            onClick={() => setShowFilter((prev) => !prev)}
                        >
                            Filter
                        </button>
                        {activeTab === 'General' && (
                            <button
                                className="btn cus-seconday-bg-btn top-btn"
                                onClick={handleNavigate}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i> Create New
                            </button>
                        )}
                    </div>
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}

                {showFilter && (
                    <div className='zIndex2'>
                        <ProductListingFilter
                            showFilter={true}
                            dispatch={dispatch}
                            useSelector={useSelector}
                            filterData={filterData}
                            setfilterData={setfilterData}
                            fetchProductList={handleFilterApply}
                            handleReset={handleFilterReset}
                            sellerList={sellerList}
                            setSellerList={setSellerList}
                            allSellers={allSellers}
                            setAllSellers={setAllSellers}
                            type="task"
                            taskCategory={activeTab}
                        />
                    </div>
                )}
                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl">
                            {allTaskListStatus === 'SUCCESS' && (
                                <DataTable
                                    headers={(() => {
                                        const baseColumns = userDetails?.Value?.isSuperAdmin ? TaskListingColumns : TaskListingSellerColumns;
                                        if (activeTab === 'ReturnPackage') {
                                            return baseColumns.map((col) =>
                                                col.key === 'sku'
                                                    ? { ...col, label: 'Tracking Number', key: 'packageTrackingNumber' }
                                                    : col
                                            );
                                        }
                                        return baseColumns;
                                    })()}
                                    tableData={allTasksList}
                                    actionType={3}
                                    handleAction={handleAction}
                                    handleSortingColumn={handleSortingColumn}
                                    tableDataStatus={allTaskListStatus}
                                    filterData={filterData}
                                />
                            )}
                        </div>
                    </div>
                    <BatchPagination
                        gridData={allTasksList}
                        totalVisualRecords={allTasksList?.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={loader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={allTaskList?.TotalRecords || 0}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                    />
                </div>
            </div>
        </main>
    );
}

export default TasksListing;